import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/b2b-portal/power-business.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundPosition: "center top",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={6} xxl={6}>
            <h2>
              Power Your Business with a Custom <span>B2B Portal</span>
            </h2>
            <p>
              Drive efficiency, security, and growth with a portal tailored to
              your business needs. Ready to scale your operations?
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Portal
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
